import { NoteFailedClientErrorCode } from '../../../../../contracts';

export class EmptyNoteStreamError extends Error {
  constructor() {
    super(NoteFailedClientErrorCode.EmptyNoteStream);
    this.name = 'EmptyNoteStreamError';
  }
}
